// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable import/named */

import { useOktaAuth } from "@okta/okta-react";
import { IUser } from "../../services/coworkerApiCalls/User/UsersTypes";
import { fullName } from "../../services/coworkerApiCalls/User/UserUtils";
import "./person.css";
import { config } from "../../utils/config/config";
import { deleteUserReservation } from "../../services/coworkerApiCalls/Reservations/Reservations";
import { ID_SPACE } from "../../constant";
import { CustomUserClaim } from "@okta/okta-auth-js";
// eslint-disable-next-line import/no-extraneous-dependencies
import { faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

/**
 * @function Person displays the avatar, the first name and the last name of a person
 * @returns {JSX.Element} HTML element
 */
function Person(properties: { user: IUser, dayDate: number, refreshReservations: () => void }) {
    const { authState } = useOktaAuth();

    const groups = authState!.idToken!.claims.groups;
    const token = authState!.idToken!.idToken
    // eslint-disable-next-line unicorn/consistent-function-scoping
    async function buttonDeleteReservation(token_: string, dayDate: number) {
        const userConfirmed = confirm("êtes vous sur de vouloir supprimer ?")
        if (userConfirmed) {
            // L'utilisateur a confirmé, appeler la fonction deleteArticle
            const reservationTimestamp: number = dayDate * 1000;
            const idSpace = ID_SPACE;
            await deleteUserReservation(token_, idSpace, properties.user.id, reservationTimestamp)
        }

    }
    // eslint-disable-next-line unicorn/consistent-function-scoping
    function ensureArray(customClaim: CustomUserClaim | CustomUserClaim[]): CustomUserClaim[] {
        // Vérifie si 'customClaim' est déjà un tableau
        // eslint-disable-next-line unicorn/prefer-ternary
        if (Array.isArray(customClaim)) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return customClaim;
        } else {
            // Si ce n'est pas un tableau, on l'encapsule dans un tableau
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return [customClaim];
        }
    }

    return (

        <div className="div-container">
            <span className="avatar">

                {ensureArray(groups).includes(`GG_APCOWORK_${config.ENV_GROUP}_EDITOR`) ?
                    <>
                        <div className="avatar-content">
                            {fullName(properties.user)}
                            <button className='small-button rounded' onClick={() => { void buttonDeleteReservation(token, properties.dayDate); properties.refreshReservations(); }}><FontAwesomeIcon icon={faTrashAlt} /></button>
                        </div>
                    </>
                    : <>
                        {fullName(properties.user)}
                    </>}


            </span>
        </div>


    );
}

export { Person };